import React from "react";
import {Tooltip, Chip} from "@material-ui/core";
import {isEmpty} from "underscore";

import {OverrideFieldName, PlaybookIssue} from "common/types/issue";
import {IssuesetId} from "common/types/issueset";
import {IssueOverrideTag} from "common/types/issue_override_tag";

interface ExistingOverrideTagsProps {
  issue: PlaybookIssue;
  issuesetId: IssuesetId;
  field: OverrideFieldName;
  selectedTag: string;
  issueOverrideTags: IssueOverrideTag[];
}

const styles = {
  container: {
    marginBottom: "4px",
    display: "flex",
    flexWrap: "wrap",
    gap: "8px",
  },
  overrideValue: {
    color: "#666",
    fontSize: "0.85rem",
    marginLeft: "4px",
  },
} as const;

const ExistingOverrideTags: React.FC<ExistingOverrideTagsProps> = ({
  issue,
  issuesetId,
  field,
  selectedTag,
  issueOverrideTags,
}) => {
  const tagOverrides = React.useMemo(
    () => issue.override_tag_values?.[issuesetId] || {},
    [issue.override_tag_values, issuesetId],
  );

  const existingOverrides = React.useMemo(() => {
    const overrides: Array<{tag: IssueOverrideTag; value: string}> = [];

    Object.entries(tagOverrides).forEach(([tagId, tagOverride]) => {
      if (tagId.toString() === selectedTag.toString()) {
        return;
      }

      const fieldValue = tagOverride.fields?.[field];
      if (fieldValue && !isEmpty(fieldValue)) {
        const tag = issueOverrideTags.find(t => t.id.toString() === tagId);
        if (tag) {
          overrides.push({
            tag,
            value: fieldValue,
          });
        }
      }
    });

    return overrides;
  }, [tagOverrides, field, selectedTag, issueOverrideTags]);

  if (!existingOverrides.length) {
    return null;
  }

  return (
    <div style={styles.container}>
      {existingOverrides.map(({tag, value}) => (
        <Tooltip
          key={tag.id}
          title={<span style={{fontSize: "1rem"}}>{value}</span>}
          placement="top"
        >
          <Chip label={tag.name} size="small" />
        </Tooltip>
      ))}
    </div>
  );
};

export default ExistingOverrideTags;
